import { handleResponse, handleError } from "./apiUtils.js";
import { generateClient } from 'aws-amplify/api';
import * as queries from '../graphql/queries.js';
import * as mutations from '../graphql/mutations.js';
import getOffsetTime from '../utils/getOffsetTime.js';
import _ from 'underscore';

const client = generateClient();

export async function getCostObjects(parameters) {
  let response = await client.graphql(
    {
      query: queries.assignmentApIgetCostObjects,
      variables:parameters
    }
  );
  return response.data.assignmentAPIgetCostObjects;
}

export async function getRelevantJobs(startTime, userId) {
  let response = await client.graphql(
    {
      query:queries.assignmentApIgetRelevantJobs,
      variables: {
        startTime,
        userId
      }
    }
  );
  return response.data.assignmentAPIgetRelevantJobs;
}

export async function getRelevantJobsForCostObject(startTime, userId, costObjectId, costObjectTypeId) {
  let response = await client.graphql(
    {
      query: queries.assignmentApIgetRelevantJobsForCostObject,
      variables: {
        startTime,
        userId,
        costObjectId,
        costObjectTypeId
      }
    }
  );
  return response.data.assignmentAPIgetRelevantJobsForCostObject;
}

export async function getRelatedBranches(userId) {

  let response = await client.graphql(
    {
      query: queries.assignmentApIgetRelatedBranches,
      variables: {
        userId
      }
    }
  );
  return response.data.assignmentAPIgetRelatedBranches;
}

export async function getGroupsByBranchAndResource(branchId, resourceId) {
  let response = await client.graphql(
    {
      query: queries.assignmentApIgetGroupsByBranchAndResource,
      variables: {
        branchId,
        resourceId
      }
    }
  );
  return response.data.assignmentAPIgetGroupsByBranchAndResource;
}

export async function getServicesByDate(branchId, resourceId, startTime, endTime, priceMethodId, groupId, timeZoneId) {

  let response = await client.graphql(
    {
      query: queries.assignmentApIgetServicesByDate,
      variables: {
        branchId,
        resourceId,
        startTime,
        endTime,
        priceMethodId,
        groupId,
        timeZoneId
      }
    }
  );
  return response.data.assignmentAPIgetServicesByDate;
}

export async function getActivityTypes(relatedServiceId, referenceDate) {

  let response = await client.graphql(
    {
      query: queries.assignmentApIgetActivityTypes,
      variables: {
        relatedServiceId,
        referenceDate
      }
    }
  );
  return response.data.assignmentAPIgetActivityTypes;
}

export async function getServiceSalaryLevel(serviceId) {

  let response = await client.graphql(
      {
        query: queries.assignmentApIgetServiceSalaryLevel, 
        variables: { serviceId }
      }
    )
    .catch(handleError);

  return response.data.assignmentAPIgetServiceSalaryLevel;
}

export async function getServicePrimaryRate(serviceId) {

  let response = await client.graphql(
      {
        query: queries.assignmentApIgetServicePrimaryRate, 
        variables: { serviceId }
      }
    )
    .catch(handleError);

  return response.data.assignmentAPIgetServicePrimaryRate;
}

export async function getJobSalariesByService(serviceId, startTime) {

  let response = await client.graphql(
    {
      query: queries.assignmentApIgetJobSalariesByService, 
      variables: { serviceId, startTime }
    }
  )
    .catch(handleError);

  return response.data.assignmentAPIgetJobSalariesByService;
}

export async function logJobStart(userId, operation) {
  let response = await client.graphql(
    {
      query: mutations.assignmentApIlogJobStart,
      variables: {
        userId,
        operation
      }
    }
  )
    .catch(handleError);

  return response.data.assignmentAPIlogJobStart;
}

export async function logJobFinish(logControlId, jobId) {

  let response = await client.graphql(
    {
      query: mutations.assignmentApIlogJobFinish,
      variables: {
        logControlId,
        jobId
      }
    }
  )
  .catch(handleError);

  return response.data.assignmentAPIlogJobFinish;
}

export async function createJob(parameters) {

  parameters.IPAddress = '27.0.0.1';

  let response = await client.graphql(
    {
      query: mutations.assignmentApIcreateJob, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.assignmentAPIcreateJob;
}

export async function createJobElement(parameters) {

  parameters.IPAddress = '27.0.0.1';

  let response = await client.graphql(
    {
      query: mutations.assignmentApIcreateJobElement, 
      variables: parameters
    }
  )
      .catch(handleError);

  return response.data.assignmentAPIcreateJobElement;
}

export async function getValidateEmptyJob(assignmentId) {

  let response = await client.graphql(
    {
      query: queries.assignmentApIgetValidateEmptyJob, 
      variables: { assignmentId }
    }
  )
    .catch(handleError);

  return response.data.assignmentAPIgetValidateEmptyJob;
}

export async function deleteJob(parameters) {

  let response = await client.graphql(
    {
      query: mutations.assignmentApIdeleteJob, 
      variables: parameters
    }
    )
    .catch(handleError);

  return response.data.assignmentAPIdeleteJob;
}

export async function deleteJobElement(parameters) {

  let response = await client.graphql(
    {
      query:mutations.assignmentApIdeleteJobElement, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.assignmentAPIdeleteJobElement;
}

export async function getJob(jobId) {

  let response = await client.graphql(
    {
      query: queries.assignmentApIgetJob, 
      variables: { jobId }
    }
  )
    .catch(handleError);

  return response.data.assignmentAPIgetJob;
}

export async function getJobElement(jobElementId) {

  let response = await client.graphql(
    {
      query: queries.assignmentApIgetJobElement, 
      variables: { jobElementId }
    }
  )
    .catch(handleError);

  return response.data.assignmentAPIgetJobElement;
}

export async function getCostObject(costObjectId, costObjectTypeId) {

  let response = await client.graphql(
    {
      query: queries.assignmentApIgetCostObject, 
      variables: { costObjectId, costObjectTypeId }
    }
  )
    .catch(handleError);

  return response.data.assignmentAPIgetCostObject;
}

export async function getJobElementsWithDetails(jobId) {

  let response = await client.graphql(
    {
      query: queries.assignmentApIgetJobElementsWithDetails, 
      variables: { jobId }
    }
  )
    .catch(handleError);

  return response.data.assignmentAPIgetJobElementsWithDetails;
}

export async function getService(serviceId) {

  let response = await client.graphql(
    {
      query: queries.assignmentApIgetService, 
      variables: { serviceId }
    }
  )
    .catch(handleError);

  return response.data.assignmentAPIgetService;
}

export async function getGroupsByBranchInCompany(branchId) {

  let response = await client.graphql(
    {
      query: queries.assignmentApIgetGroupsByBranchInCompany, 
      variables: { branchId }
    }
  )
    .catch(handleError);

  return response.data.assignmentAPIgetGroupsByBranchInCompany;
}

export async function getAssignmentServicesByGroup(groupId, serviceId) {

  let response = await client.graphql(
    {
      query: queries.assignmentApIgetAssignmentServicesByGroup, 
      variables: { groupId, serviceId }
    }
  )
    .catch(handleError);

  return response.data.assignmentAPIgetAssignmentServicesByGroup;
}

export async function getServicesByGroup(groupId, serviceId) {

  let response = await client.graphql(
    {
      query: queries.assignmentApIgetServicesByGroup, 
      variables: { groupId, serviceId }
    }
  )
    .catch(handleError);

  return response.data.assignmentAPIgetServicesByGroup;
}


export async function updateJobElement(parameters) {

  parameters.IPAddress = '27.0.0.1';
  // console.log('***** UPDATE JOB ELEMENT PARAMETERS ******'); // debug
  // console.log(parameters); // debug

  let response = await client.graphql(
    {
      query: mutations.assignmentApIupdateJobElement, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.assignmentAPIupdateJobElement;
}

export async function getJobElements(jobId) {

  let response = await client.graphql(
    {
      query: queries.assignmentApIgetJobElements, 
      variables: { jobId }
    }
  )
    .catch(handleError);

  return response.data.assignmentAPIgetJobElements;
}

export async function getApprovedJobElements(jobId) {

  let response = await client.graphql(
    {
      query: queries.assignmentApIgetApprovedJobElements, 
      variables: { jobId }
    }
  )
    .catch(handleError);

  return response.data.assignmentAPIgetApprovedJobElements;
}

export async function updateJob(parameters) {
  parameters.IPAddress = '27.0.0.1';
  let response = await client.graphql(
    {
      query: mutations.assignmentApIupdateJob, 
      variables: parameters
    }
  )
    .catch(handleError);

  return response.data.assignmentAPIupdateJob;
}

